import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/h/[slug]/chronicles/[chronicleSlug]/ChronicleClient.jsx");
